import React from "react";
import ReactDOM from "react-dom";
import Routes from "./redux/config/Routes/Routes";
import registerServiceWorker from "./registerServiceWorker";
import injectTapEventPlugin from "react-tap-event-plugin";
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import "./styles/scss/style.css";
import "./redux/config/index";

// ---------------------- Redux -----------------------------
import { Provider } from "react-redux";
import configureStore from "./redux/store/configureStore";
export const store = configureStore();

injectTapEventPlugin();
ReactDOM.render(
  <MuiThemeProvider>
    <Provider store={store}>
      <Routes />
    </Provider>
  </MuiThemeProvider>,
  document.getElementById("root")
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js